import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/button';
import GoogleIcon from 'components/icon/google-icon';
import GithubIcon from 'components/icon/github-icon';
import MailIcon from 'components/icon/mail-icon';
import oauth from 'services/oauth';
import './oauth-buttons.scss';

const { GOOGLE_CLIENT_ID, GITHUB_CLIENT_ID } = process.env;

export default class OAuthButtons extends React.PureComponent {
  static propTypes = {
    flow: PropTypes.oneOf(['login', 'signup']).isRequired,
    onContinueWithEmail: PropTypes.func,
    partnerId: PropTypes.string,
  };

  onClickGoogle = () => {
    oauth.startOAuth('google', this.props.flow, this.props.partnerId);
  };

  onClickGithub = () => {
    oauth.startOAuth('github', this.props.flow, this.props.partnerId);
  };

  render() {
    const { flow, onContinueWithEmail } = this.props;
    const verb = flow === 'login' ? 'Log in with' : 'Continue with';

    if (!GOOGLE_CLIENT_ID && !GITHUB_CLIENT_ID && !onContinueWithEmail) {
      return null;
    }

    return (
      <div className="oauth-buttons">
        {GOOGLE_CLIENT_ID && (
          <Button
            type="button"
            styleType="secondary"
            size="large"
            onClick={this.onClickGoogle}
          >
            <GoogleIcon />
            {verb} Google
          </Button>
        )}
        {GITHUB_CLIENT_ID && (
          <Button
            type="button"
            styleType="secondary"
            size="large"
            onClick={this.onClickGithub}
          >
            <GithubIcon />
            {verb} Github
          </Button>
        )}
        {onContinueWithEmail && (
          <Button
            type="button"
            styleType="secondary"
            size="large"
            onClick={onContinueWithEmail}
          >
            <MailIcon />
            Continue with Email
          </Button>
        )}
      </div>
    );
  }
}
